import React from 'react';
import {useEvent} from '../../../data/hooks/eventHooks';
import {useI18n} from '../../../data/hooks/i18nHooks';
import RelativeRedirect from '../../elements/RelativeRedirect/RelativeRedirect';
import ScreenTitle from '../../elements/ScreenTitle/ScreenTitle';
import ScrollableList from '../../elements/ScrollableList';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import LoadNews from '../../loaders/LoadNews';
import {useFallbackRoute} from '../../validate/useFallbackRoute';
import WaitWhileBusy from '../../WaitWhileBusy';
import Screen from '../Screen';
import EventNotificationsItem from './EventNotificationsItem';
import {useMergedNotifications} from './useMergedNotifications';

function EventNotifications(props) {
    const {eventId} = props,
        event = useEvent(eventId),
        newsMergedWithNotifications = useMergedNotifications(eventId),
        i18n = useI18n();

    if (!newsMergedWithNotifications.length) {
        return <RelativeRedirect to=".." />;
    }

    // Screen header
    const header = (
        <>
            <TopBarEvent event={event} />
            <br />
            <ScreenTitle screen={i18n['label.Notifications']} event={event} />
        </>
    );

    // Screen content
    return (
        <Screen header={header}>
            <ScrollableList>
                {newsMergedWithNotifications.map((item, i) => (
                    <EventNotificationsItem key={i} item={item} />
                ))}
            </ScrollableList>
        </Screen>
    );
}

// route validation and data fetching
export default props => {
    const event = useEvent(props.eventId), // if not defined, it uses the one from the route
        fallbackRoute = useFallbackRoute(),
        fallback = !event;

    if (fallback) return <RelativeRedirect to={fallbackRoute} />;

    return (
        <LoadNews eventId={event.id}>
            <WaitWhileBusy>
                <EventNotifications eventId={event.id} />
            </WaitWhileBusy>
        </LoadNews>
    );
};
